import AbstractJobApplyForm from "./job_apply_forms";

class StepAdditionalInfo extends AbstractJobApplyForm {

  constructor(currentStepFormId) {
    super(currentStepFormId);

    this.initPage();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.$customFields !== 'undefined' && document.getElementById('job-apply-form-step-additional-info')) {
    new StepAdditionalInfo('job-apply-form-step-additional-info');
  }
});
